import(/* webpackMode: "eager" */ "/app/src/app/dashboard/page.tsx");
